angular.module('iw.frontyard.translate', [
    'iw.frontyard.string',
]);